module.exports = __webpack_public_path__ + "img/max-envelope-subtract.2d9fd6a6.svg";